import { ActionTypes } from "./actions";
import { defaultState, bindReducers } from "src/utils/genState";
import createReducer from "src/utils/reduxsauce/createReducer";

const initialState = {
  ...defaultState("starterKits", { metadata: undefined }, []),
};

const editStarterKitSuccess = (state, draft, payload) => {
  const index = state.starterKits.findIndex((r) => r.id === payload.id);
  if (index >= 0) {
    draft.starterKits[index] = payload;
  }
  draft.openDialog = false;
};

const starterKitCreatedSuccess = (state, draft, payload) => {
  const starterKits = state.starterKits || [];
  draft.starterKits = [...starterKits, payload];
  draft.openDialog = false;
};

const starterKitDeleteSuccess = (state, draft, payload) => {
  const starterKits = state.starterKits || [];
  draft.starterKits = starterKits.filter((a) => a.id != payload.id);
  draft.openDeleteDialog = false;
};

const showDialog = (state, draft, payload) => {
  draft.openDialog = true;
};

const showDeleteDialog = (state, draft, payload) => {
  draft.openDeleteDialog = true;
};

const resetDialog = (state, draft, payload) => {
  draft.openDialog = false;
  draft.openDeleteDialog = false;
};

export const reducer = createReducer(initialState, {
  ...bindReducers(ActionTypes, {
    action: "getAllStarterKits",
    stateName: "starterKits",
    async: true,
    isPaginated: true,
  }),
  ...bindReducers(ActionTypes, {
    action: "createStarterKit",
    stateName: "starterKit",
    async: true,
    isPaginated: false,
    successCb: starterKitCreatedSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "editStarterKit",
    stateName: "starterKit",
    async: true,
    isPaginated: false,
    successCb: editStarterKitSuccess,
  }),
  ...bindReducers(ActionTypes, {
    action: "deleteStarterKit",
    stateName: "starterKit",
    async: true,
    isPaginated: false,
    successCb: starterKitDeleteSuccess,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDeleteDialog",
    stateName: "showDeleteDialog",
    async: false,
    isPaginated: false,
    successCb: showDeleteDialog,
  }),

  ...bindReducers(ActionTypes, {
    action: "showDialog",
    stateName: "showDialog",
    async: false,
    isPaginated: false,
    successCb: showDialog,
  }),
  ...bindReducers(ActionTypes, {
    action: "resetDialog",
    stateName: "resetDialog",
    async: false,
    isPaginated: false,
    successCb: resetDialog,
  }),
});
